import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest, protectedResources } from "../authConfig";
import LoadingSpinner from "../components/LoadingSpinner";
import React, { useEffect, useState } from 'react';
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { Button } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { DateTime } from "luxon";
import ShowToast from '../components/ShowToast.jsx';
import PropTypes from 'prop-types';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const ReportsGrid = ({ administrator }) => {
    ReportsGrid.propTypes = {
        administrator: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.oneOf([null])
        ])
    };

    const STORAGE_KEY = "ReportsGrid_filters";

    const authRequest = { ...loginRequest, };

    const { isLoading, error, execute } = useFetchWithMsal({
        scopes: protectedResources.api.scopes
    });

    const loadStoredFilters = () => {
        const storedFilters = localStorage.getItem(STORAGE_KEY);
        return storedFilters ? JSON.parse(storedFilters) : { fecha: "", nombre: "", tipo: "" };
    };

    const [data, setData] = useState([]);
    const [filters, setFilters] = useState(loadStoredFilters);

    useEffect(() => {
        execute("GET", protectedResources.api.reports).then((response) => {
            if (response?.data) {
                setData(response.data);
            }
        });

    }, [execute]);

    const filteredData = data.filter(row => {
        const fechaFormatted = row.createdAt ? row.createdAt.toLowerCase() : "";
        const nombre = row.description ? row.description.toLowerCase() : "";
        const tipo = row.reportType ? row.reportType.toLowerCase() : "";

        return (
            (!filters.fecha || fechaFormatted.includes(filters.fecha)) &&
            (!filters.nombre || nombre.includes(filters.nombre.toLowerCase())) &&
            (!filters.tipo || tipo.includes(filters.tipo.toLowerCase()))
        );
    });

    const handleFilterChange = (field, value) => {
        setFilters(prev => {
            const newFilters = { ...prev, [field]: value };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(newFilters));
            return newFilters;
        });
    };

    const crearReporteDefinitivo = () => {
        execute("POST", protectedResources.api.reports).then((response) => {
            if (response && response.status == 200) {
                ShowToast("success", "Los reportes se están generado, actualiza en 15 segundos");
            } else {
                ShowToast("error", response?.message);
            }
        }).catch((error) => {
            console.log(error);
            ShowToast("error", "Error al generar el reporte");
        });
    };

    const columns = [
        {
            // name: "Fecha",
            selector: row => row.createdAt,
            sortable: true,
            grow: 1,
            width: "15%",
            cell: row => row.createdAt,
            filterComponent: (
                <input
                    type="text"
                    placeholder="Fecha"
                    className="form-control"
                    value={filters.fecha}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => handleFilterChange("fecha", e.target.value)}
                />
            )
        },
        {
            // name: "Nombre",
            selector: row => row.description,
            sortable: true,
            grow: 1,
            width: "40%",
            cell: row => row.description,
            filterComponent: (
                <input
                    type="text"
                    placeholder="Nombre"
                    className="form-control"
                    value={filters.nombre}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => handleFilterChange("nombre", e.target.value)}
                />
            )
        },
        {
            // name: "Tipo",
            selector: row => row.reportType,
            sortable: true,
            grow: 1,
            width: "25%",
            cell: row => row.reportType,
            filterComponent: (
                <input
                    type="text"
                    placeholder="Tipo"
                    className="form-control"
                    value={filters.tipo}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => handleFilterChange("tipo", e.target.value)}
                />
            )
        },
        {
            name: "Descargar Reporte",
            cell: row => (
                <a href={row.file?.signedUrl} target="_blank" rel="noopener noreferrer">
                    <Button variant="outline-success" size="sm">
                        <i className="fa fa-download me-1" /> Descargar
                    </Button>
                </a>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            minWidth: '200px',
            width: "20%"
        },
    ];

    const renderForm = (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest}>
            <div className="container">
                {administrator?.isAdmin && (
                    <div className="d-flex justify-content-end pe-3 pt-3">
                        <Button className="mb-3" onClick={crearReporteDefinitivo}>
                            <i className="fa fa-chart-bar me-1" /> Reporte definitivo
                        </Button>
                    </div>
                )}
                <DataTable
                    columns={columns.map(col => ({
                        ...col,
                        name: (
                            <div style={{ textAlign: 'center', width: '100%' }}>
                                {col.name}
                                {col.filterComponent && <div>{col.filterComponent}</div>}
                            </div>
                        )
                    }))}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    responsive
                    fixedHeader
                    noDataComponent="No hay datos disponibles"
                    persistTableHead
                />
            </div>
        </MsalAuthenticationTemplate>
    );

    return (
        <div className="container"> {isLoading ? <LoadingSpinner /> : renderForm}</div>
    );
}